import { render, staticRenderFns } from "./DownloadDocuments.vue?vue&type=template&id=4d2a8a0a&scoped=true"
import script from "./DownloadDocuments.vue?vue&type=script&lang=js"
export * from "./DownloadDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2a8a0a",
  null
  
)

export default component.exports